import { type PremiumFeatures } from '@lub0v/santa-utils';

/** The server resolves grant activity and expiry before returning these entitlements. */
export function hasAdFreeAccess(owner?: { isPremium?: boolean; features?: Partial<PremiumFeatures> } | null): boolean {
  return owner?.features?.adsDisabled === true;
}

/** Management routes are ad-free regardless of paid entitlements. */
export function isOrganizerManagementPage(
  route: { key: string; view: string; card: boolean } | null,
  info?: { box: { key: string; mode?: string }; isAdmin?: boolean; isParticipant?: boolean } | null,
): boolean {
  if (!route || route.card) return false;
  if (route.view === 'organizer' || route.view === 'settings') return true;
  const current = info?.box.key === route.key ? info : null;
  // Wait for the role before enabling ads on a shared game landing page.
  if (route.view === 'home' || route.view === 'main') return !current || Boolean(current.isAdmin);
  if (!current?.isAdmin) return false;
  return current.box.mode === 'quick' || (route.view === 'exchange' && !current.isParticipant);
}
